import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { Container } from "reactstrap";
import { TextField, Breadcrumbs, IconButton, InputBase, Paper } from "@mui/material";
import CompanyMemberAddModal from './CompanyMemberAddModal';
import CompanyMemberInviteModal from './CompanyMemberInviteModal';
import CompanyMemberTableBlock from './CompanyMemberTableBlock';
import toastAlert from '../../../js/Base/ToastAlert';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import SearchIcon from '@mui/icons-material/Search';
import { getCompanyMembersByCompanyId } from '../../../api/companyApi';

export default function CompanyMemberManagement() {
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [inviteModalOpen, setInviteModalOpen] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);

  useEffect(() => {
    getCompanyMembers();
  }, []);

  const getCompanyMembers = async () => {
    const companyUuid = localStorage.getItem('company_uuid');
    if (!companyUuid) {
      setLoading(false);
      toastAlert.autoClose(true).showError("查無資料，請聯絡系統管理員");
      return;
    }

    try {
      setLoading(true);
      const response = await getCompanyMembersByCompanyId(companyUuid);
      const data = response.data;

      if (data.success) {
        setRows(data.members);
      } else {
        toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
      }
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
    } finally {
      setLoading(false);
    }
  };

  const handleInviteModalOpen = () => setInviteModalOpen(true);
  const handleInviteModalClose = () => setInviteModalOpen(false);
  const handleAddModalOpen = () => setAddModalOpen(true);
  const handleAddModalClose = () => setAddModalOpen(false);
  const handleSearchChange = (e) => setSearch(e.target.value);


  return (
    <React.Fragment>
      <Container className="mt-2">
        <div style={{ marginRight: '20px' }}>
          <Breadcrumbs
            className="link-area"
            style={{ padding: "0 0 20px 0", fontWeight: 'bold'}}
            separator={<NavigateNextIcon style={{ fontSize: '20px', fontWeight: 'bold' }} />}
            aria-label="breadcrumb"
          >
            <Link to="/admin-management" style={{ color: '#1d1d1d', fontSize: '20px', textDecoration: 'none', fontWeight: 'bold' }}>
              <p style={{ marginBottom: '0px' }}>公司管理</p>
            </Link>
            <Link to="/company/company-member-management" style={{ color: '#1d1d1d', fontSize: '20px', textDecoration: 'none', fontWeight: 'bold' }}>
              <p style={{ marginBottom: '0px' }}>帳號管理</p>
            </Link>
          </Breadcrumbs>

        <Card style={{ marginBottom: '50px'}}>
          <Card.Header style={{ backgroundColor: 'transparent' }}>
            <strong style={{ fontSize:'16px', fontWeight: 'bold', fontFamily: 'Arial, sans-serif' }}>公司帳號成員管理</strong>
          </Card.Header>
            <Card.Body style={{ paddingTop: "5px" }}>
              <Row className="mb-3 mt-3">
                <Col md={4}>
                  <Paper variant="outlined" component="form" sx={{ p: '2px 2px', display: 'flex', alignItems: 'left', height: '32px' }}>
                    <InputBase
                      sx={{ flex: 1, p: '10px' }}
                      style={{ fontSize: '12px', boxShadow: 'none' }}
                      placeholder="請輸入姓名或帳號"
                      inputProps={{ 'aria-label': 'search keyword' }}
                      value={search}
                      onChange={handleSearchChange}
                    />
                    <IconButton type="button" sx={{ p: '12px' }} aria-label="search">
                      <SearchIcon style={{ color: '#E2E2E2' }} />
                    </IconButton>
                  </Paper>
                </Col>
                <Col md={6}></Col>
                <Col md={2} className="CompanyManagement d-flex">
                  <Button
                    className="btn-invite me-0"
                    style={{
                      fontSize: '14px',
                      color: '#323232',
                      borderRadius: '4px 0 0 4px',
                      backgroundColor: '#fff',
                      cursor: 'pointer',
                      padding: '0px',
                      margin: '0px',
                    }}
                    onClick={handleAddModalOpen}>
                    新增人員
                  </Button>
                  <Button
                    className="btn-invite me-0"
                    style={{
                      fontSize: '14px',
                      color: '#323232',
                      borderRadius: '0 4px 4px 0',
                      backgroundColor: '#fff',
                      cursor: 'pointer',
                      padding: '0px',
                      margin: '0px',
                    }}onClick={handleInviteModalOpen}>
                    人員邀請
                  </Button>
                </Col>
              </Row>

              <CompanyMemberAddModal
                isModalOpen={addModalOpen}
                handleClose={handleAddModalClose}
                submitEffect={getCompanyMembers}
              />
              <CompanyMemberInviteModal
                isModalOpen={inviteModalOpen}
                handleClose={handleInviteModalClose}
                submitEffect={getCompanyMembers}
              />

              {rows.length > 0 && (
                <CompanyMemberTableBlock
                  rows={rows}
                  search={search}
                  refreshData={getCompanyMembers}
                />
              )}
            </Card.Body>
          </Card>
        </div>
      </Container>
    </React.Fragment>
  );
}
